/**
 * Status eines Account/Zugangs
 */
export enum AccountStatus {
   /**
    * Account/Zugang angelegt. Kundenbestätigung wird noch benötigt.
    */
   confirmationPending = "confirmationPending",

   /**
    * Account/Zugang angelegt und bestätigt.
    */
   active = "active",

   /**
    * Account/Zugang alt und aussortiert.
    */
   deleted = "deleted",
}

export const AccountStatusNames = {
   confirmationPending: "Kundenbestätigung ausstehend",
   active: "Aktiviert",
   deleted: "Gelöscht"
};